export type AuthModalMode = 'login' | 'register'

export const useAuthModal = defineStore('authModal', () => {
  const isOpen = ref(false)
  const mode = ref<AuthModalMode>('login')
  const email = ref('')
  let _onSuccess: (() => void) | null = null
  const localePath = useLocalePath()

  function open(opts?: {
    mode?: AuthModalMode
    onSuccess?: () => void
  }) {
    email.value = ''
    mode.value = opts?.mode ?? 'login'
    _onSuccess = opts?.onSuccess ?? null
    isOpen.value = true
  }

  function setMode(m: AuthModalMode, emailVal?: string) {
    mode.value = m
    if (emailVal !== undefined) email.value = emailVal
  }

  function close() {
    isOpen.value = false
  }

  function success() {
    if (_onSuccess) {
      _onSuccess()
    } else {
      navigateTo(localePath({ name: 'account-orders' }))
    }
    isOpen.value = false
  }

  return { isOpen, mode, email, open, setMode, close, success }
})
